function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { Button, Card, Skeleton, notification, Drawer } from "antd";
import Common from "../components/includes/Common";
import { BoxArrowInLeft, PrinterFill } from "react-bootstrap-icons";
import CompanyVaSheet from "../components/CompanyVaSheet";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var VaPlanning = function VaPlanning() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    companyList = _useState2[0],
    setCompanyList = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    estimatedCount = _useState4[0],
    setEstimatedCount = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showList = _useState6[0],
    setShowList = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    companiesLoading = _useState8[0],
    setCompaniesLoading = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedCompany = _useState0[0],
    setSelectedCompany = _useState0[1];
  var ref = useRef();
  useEffect(function () {
    setCompaniesLoading(true);
    axios.get(Common.baseApiUrl + "getplanningcompanies/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setCompanyList(response.data.companies);
        setEstimatedCount(response.data.count);
      } else {
        notification.error({
          message: "Erreur!",
          description: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur!",
        description: "Une erreur est survenue " + error.toString()
      });
    })["finally"](function () {
      setCompaniesLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              color: "#EEE",
              padding: "8px 18px",
              background: "#1F6957",
              borderRadius: "4px"
            },
            children: ["Nombre de candidats potentiels pour une visite annuelle ", estimatedCount.toLocaleString("Fr")]
          })
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: companiesLoading ? /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })
          }) : /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsxs(Table, {
              responsive: true,
              bordered: true,
              striped: true,
              children: [/*#__PURE__*/_jsx("thead", {
                children: /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("th", {
                    children: "SOCIETE"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "E-mail"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Nombre de candidats"
                  }), /*#__PURE__*/_jsx("th", {})]
                })
              }), /*#__PURE__*/_jsx("tbody", {
                children: companyList.map(function (c) {
                  return /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: c.label
                    }), /*#__PURE__*/_jsx("td", {
                      children: c.email
                    }), /*#__PURE__*/_jsx("td", {
                      children: c.customers_count.toLocaleString("Fr")
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Button, {
                        onClick: function onClick() {
                          setSelectedCompany(c);
                          setShowList(true);
                        },
                        type: "link",
                        children: /*#__PURE__*/_jsx("b", {
                          children: /*#__PURE__*/_jsx(BoxArrowInLeft, {
                            size: 32
                          })
                        })
                      })
                    })]
                  }, c.id);
                })
              })]
            })
          })
        })
      })]
    }), selectedCompany && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsxs("b", {
        children: ["Liste de candidats pour - ", selectedCompany.short_name]
      }),
      width: "85%",
      open: showList,
      onClose: function onClose() {
        setShowList(false);
      },
      destroyOnClose: true,
      headerStyle: {
        background: "#F7F2F2"
      },
      extra: [/*#__PURE__*/_jsx(ReactToPrint, {
        content: function content() {
          return ref.current;
        },
        children: /*#__PURE__*/_jsx(PrintContextConsumer, {
          children: function children(_ref) {
            var handlePrint = _ref.handlePrint;
            return /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: handlePrint,
              children: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(PrinterFill, {
                  size: 18
                }), " IMPRIMER"]
              })
            });
          }
        })
      })],
      children: /*#__PURE__*/_jsx(CompanyVaSheet, {
        ref: ref,
        company: selectedCompany
      })
    })]
  });
};
export default VaPlanning;